import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function CostComparison() {
  const rows = [{
    sin: '3-5 horas/semana planificando desde cero',
    con: '10 min/semana. El resto es estar en el agua'
  }, {
    sin: 'Siempre los mismos ejercicios → las alumnas se aburren',
    con: '60+ clases distintas → siempre hay algo nuevo'
  }, {
    sin: 'Alumnas que abandonan sin saber por qué',
    con: 'Sistema de progresión → retención visible'
  }, {
    sin: 'Sin progresión clara de nivel a nivel',
    con: '6 tomos con progresión anual → mejoran y se quedan'
  }, {
    sin: 'Alumna con dificultad = pánico o improvisación',
    con: 'Protocolo técnico → actuás con confianza'
  }, {
    sin: 'Niveles mezclados = caos de clase',
    con: 'Variaciones por nivel → todas mejoran juntas'
  }, {
    sin: 'Sin sistema de seguimiento claro',
    con: 'Fichas y planillas listas para registrar con criterio'
  }, {
    sin: 'Sin identidad profesional visible',
    con: 'Sistema que justifica cobrar lo que merecés'
  }];
  return <section className="py-12 md:py-24 bg-slate-50 border-t border-slate-200" data-id="element-52">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <FadeIn data-id="element-54">
          <div className="text-center mb-6 md:mb-12" data-id="element-55">
            <h2 className="text-3xl md:text-5xl font-display font-black text-deepblue-900" data-id="element-56">
              ¿Cuánto cuesta NO tenerlo?
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-57">
          {/* Mobile: stacked cards */}
          <div className="md:hidden space-y-2" data-id="element-58">
            {rows.map((row, i) => <div key={i} className="bg-white rounded-lg border border-slate-200 overflow-hidden" data-id="element-59">
                <div className="p-3 flex items-start gap-2 bg-rose-50/50 border-b border-slate-100" data-id="element-60">
                  <XCircle className="w-4 h-4 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-61" />
                  <span className="text-slate-500 text-xs line-through" data-id="element-62">
                    {row.sin}
                  </span>
                </div>
                <div className="p-3 flex items-start gap-2 bg-aqua-50/50" data-id="element-63">
                  <CheckCircle2 className="w-4 h-4 text-aqua-600 flex-shrink-0 mt-0.5" data-id="element-64" />
                  <span className="text-deepblue-900 font-medium text-xs" data-id="element-65">
                    {row.con}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Desktop: table */}
          <div className="hidden md:block overflow-x-auto rounded-3xl border border-slate-200 shadow-xl shadow-slate-200/50 bg-white" data-id="element-66">
            <table className="w-full text-left border-collapse" data-id="element-67">
              <thead data-id="element-68">
                <tr data-id="element-69">
                  <th className="bg-rose-50 p-6 font-display font-bold text-rose-900 w-1/2 border-b border-rose-100 text-lg text-center" data-id="element-70">
                    SIN AQUAGYM RESUELTO
                  </th>
                  <th className="bg-aqua-600 p-6 font-display font-bold text-white w-1/2 border-b border-aqua-700 text-lg text-center" data-id="element-71">
                    CON AQUAGYM RESUELTO
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-72">
                {rows.map((row, i) => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-73">
                    <td className="p-5 text-slate-600 flex items-center gap-3" data-id="element-74">
                      <XCircle className="w-5 h-5 text-rose-400 flex-shrink-0" data-id="element-75" />
                      {row.sin}
                    </td>
                    <td className="p-5 text-deepblue-900 font-medium bg-aqua-50/30" data-id="element-76">
                      <div className="flex items-center gap-3" data-id="element-77">
                        <CheckCircle2 className="w-5 h-5 text-aqua-600 flex-shrink-0" data-id="element-78" />
                        {row.con}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </FadeIn>
      </div>
    </section>;
}